/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ActionStatusEnum;

(function (ActionStatusEnum) {
  ActionStatusEnum["ACCEPT"] = "ACCEPT";
  ActionStatusEnum["REFERRAL"] = "REFERRAL";
  ActionStatusEnum["DECLINE"] = "DECLINE";
  ActionStatusEnum["INVALID"] = "INVALID";
  ActionStatusEnum["UNKNOWN"] = "UNKNOWN";
})(ActionStatusEnum || (ActionStatusEnum = {}));